import { rootStore } from 'store/root';
import appApi from 'service/app-api';

const { nxlApi } = window;

nxlApi.appsLauncherEvents.sub((key: string, data: any) => {
    const productId = data.productID;
    const one = rootStore.appStore.library.find(x => x.productId === productId);
    if (!one) return;
    switch (key) {
        case 'appRunning':
            appApi.lastActiveTimeAny = Date.now() / 1000;
            appApi.lastActiveTime[productId] = appApi.lastActiveTimeAny;
            appApi.appClosed[productId] = false;
            break;
        case 'appClosed':
            appApi.appClosed[productId] = true;
            break;
        case 'productStateChanged':
            one.installInfo.updateCurrentState(data.state);
            break;
        case 'branchChanged':
            one.installInfo.setBranchName(data.branchName);
            break;
        default:
    }
});
